export default "__VITE_ASSET__BKEx0auO__"